export { default as HomePage } from './HomePage'
export { default as AboutPage } from './AboutPage'
export { default as ContactUs } from './ContactUs'
export { default as TermsofServicePage } from './TermsofServicePage'
export { default as PricingPage } from './PricingPage'
export { default as PrivacyPolicyPage } from './PrivacyPolicyPage'
export { default as PricingHomePage } from './pricing/PricingHomePage'
